import * as React from "react";
import { SearchBox, ISearchBoxStyles, ISearchBoxProps } from "@fluentui/react/lib/SearchBox";

const searchBoxStyles: Partial<ISearchBoxStyles> = { root: { width: 200 } };

/* eslint-disable react/jsx-no-bind */
// { iconProps: { iconName: "Clear" } }
const SearchBoxSmallExample = (props: {
  item: ISearchBoxProps
}) => {
  const ariaLabel = props.item.ariaLabel || props.item.placeholder || "Search";
  const clearButtonProps = props.item.clearButtonProps
    ? { ...props.item.clearButtonProps, ariaLabel: props.item.clearButtonProps.ariaLabel || "Clear search" }
    : { ariaLabel: "Clear search" };

  return (
    <SearchBox
      styles={props.item.styles}
      placeholder={props.item.placeholder}
      ariaLabel={ariaLabel}
      clearButtonProps={clearButtonProps}
      onEscape={props.item.onEscape}
      onClear={props.item.onClear}
      onChange={props.item.onChange}
      onSearch={props.item.onSearch}
      showIcon={true}
    />
  );
};
export default SearchBoxSmallExample;
